import React, { Fragment, useEffect } from 'react'
import styles from './app.styles'
import injectSheet from 'react-jss'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import SignIn from '../screens/sign-in/sign-in'
import SignUp from '../screens/sign-up/sign-up'
import SignOut from '../screens/sign-out/sign-out'
import MagicLinks from '../screens/magic-links/magic-links.container'
import FinishSignup from '../screens/finish-signup/finish-signup'
import ForgotPassword from '../screens/forgot-password/forgot-password.container'
import { ToastContainer } from 'pobble-components/dist/toast'
import { APP_PATH } from '../../config'
import EnvironmentLine from 'pobble-components/dist/environment-line'
import OauthCallback from '../screens/sign-in/head/oauth/oauth-callback/oauth-callback.container'
import PageNotFound from 'pobble-components/dist/page-not-found'
import { MyLoginOauthCallback } from '../oauth/my-login-oauth'
import posthog from 'posthog-js'

function App({ classes }) {
  useEffect(() => {
    posthog.capture('landed on auth spa')
  }, [])

  return (
    <Router basename={APP_PATH}>
      <Fragment>
        <EnvironmentLine />
        <Switch>
          <Route exact path="/" component={SignIn} />
          <Route path="/sign-up" component={SignUp} />
          <Route path="/sign-out" component={SignOut} />
          <Route path="/mylogin-callback" component={MyLoginOauthCallback} />
          <Route path="/oauth-callback/:provider" component={OauthCallback} />
          <Route path="/forgot-password" component={ForgotPassword} />
          <Route exact path="/ml/:token/:action" component={MagicLinks} />
          <Route exact path="/finish-signup" component={FinishSignup} />
          <Route
            component={() => <PageNotFound className={classes.pageNotFound} />}
          />
        </Switch>
        <ToastContainer />
      </Fragment>
    </Router>
  )
}

export default injectSheet(styles)(App)
